import { render, staticRenderFns } from "./PosDialog.vue?vue&type=template&id=5c3c5d5e"
import script from "./PosDialog.vue?vue&type=script&lang=js"
export * from "./PosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports